import { getFormattedDate } from "../utils/utils";

export class OrderListModel {
  constructor(data) {
    const {
      status,
      user: { firstName, lastName },
      order: { orderId, companyName },
      term,
      id,
      updatedAt,
      approver
    } = data || {};
    this.legalBusinessNameFM = companyName || '';
    this.accountManager = `${firstName} ${lastName}`;
    this.id = id;
    this.orderId = orderId;
    this.term = term;
    this.status = status;
    this.approverName = approver ? `${approver.firstName} ${approver.lastName}` : '-';
    this['Date Submitted'] = status === 'Approved' || status === 'Rejected' ? getFormattedDate(updatedAt, 'YYYY-MM-DD'): '-';
  }
}
